import { apiSdk } from '@/httpClient';
import { Select, SelectProps } from 'antd';
import React from 'react';
import { useQuery } from 'react-query';

interface Props extends SelectProps<any> {
  companyId?: string | null | undefined;
}

export default function AdvertisingBaseTripInput({ companyId, ...props }: Props) {
  const { data, isLoading } = useQuery(
    ['useGetAdvertisingBaseTripInput', companyId],
    async () => {
      return await apiSdk.LianeAdvertisingService.getBaseTripAutoCompletion({ companyId: companyId || '', limit: 200 });
    },
    { enabled: !!companyId },
  );
  return (
    <Select
      maxTagCount="responsive"
      allowClear
      loading={isLoading}
      {...props}
      filterOption={(input, option) => {
        return (option?.children as any)?.toLowerCase().includes(input.toLowerCase());
      }}
      showSearch={true}
    >
      {data?.map(c => {
        return (
          <Select.Option key={c.id} value={c.id}>
            {`${c.tripRefNo} - ${c.tripName}`}
          </Select.Option>
        );
      })}
    </Select>
  );
}
